import axios from "axios";

// REACT_APP_API_URL  → set per environment in .env.development / .env.staging / .env.production
// REACT_APP_API_ENV  → must match NODE_ENV used by FMS-api (local | development | staging | production)
const API_BASE = process.env.REACT_APP_API_URL;
const API_ENV = process.env.REACT_APP_API_ENV || "local";

const axiosInstance = axios.create({
  baseURL: `${API_BASE}/api/${API_ENV}`,
  withCredentials: true
});

export default axiosInstance;
